import type { FaireProductEntity } from "../../entity_types/product";

export const p_u68c3zzw3v: FaireProductEntity = {
  token: "p_u68c3zzw3v",
  type: "product",
  name: "Minnesota Watercolor Workbook - Video Directions Included",
  brandName: "Alyssa Whetstone Art",
  imageUrl:
    "https://cdn.faire.com/fastly/c3607317a6ba1caecb22792aa5f183b4cb211069466c5e23239c378ff5b17300.png",
  priceDollars: 13,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0ef3fef4c552238f95520fc1837b8c8348b414080da7cce17da0167de8246a39.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
